export default "__VITE_ASSET__BRW31W9c__"